require('../../modules/es6.number.is-finite');
module.exports = require('../../modules/$.core').Number.isFinite;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-finite.js
// module id = 1245
// module chunks = 1